import React, { ReactNode } from 'react';
import { Space, Button, ButtonProps } from 'antd';

export type JActionsButton = {
  /** Testo del bottone */
  label?: string;
  /** Render del bottone  */
  render?: NonNullable<ReactNode>;
  /** props del componente antd https://ant.design/components/button/#API */
  props?: ButtonProps;
};

export interface JActionsProps {
  /** Array dei Bottoni: */
  buttons: JActionsButton[];
}

/**
 * Azioni nella tabella
 * @param buttons
 * @constructor
 */
export const JTableActions = ({ buttons }: JActionsProps) => (
  <Space>
    {buttons.map((button, key) => (
      <React.Fragment key={`jaction-button-${key}`}>
        {button.render ? (
          button.render
        ) : (
          <Button {...button.props}>{button.label ? button.label : ''}</Button>
        )}
      </React.Fragment>
    ))}
  </Space>
);
